import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApiConstant } from '../index';
import { SimulationLazyModule } from './simulation-lazy.module';
import { API_TOKEN } from './types';
@NgModule({
    imports: [SimulationLazyModule],
    exports: [SimulationLazyModule],
})
export class SimulationModule {
    static forRoot(apiConstantt: ApiConstant): ModuleWithProviders<SimulationModule> {
        return {
            ngModule: SimulationModule,
            providers: [{ provide: API_TOKEN, useValue: apiConstantt }],
        };
    }
}
